module.exports = __webpack_public_path__ + "img/pb-logo.dcc92f7f.png";